import React, { useState, useEffect } from 'react';
import './styles/modusers.scss';
import axios from 'axios';
import { server_address as proxy } from '../custom-modules/serverAddress';

import hidden_icon from '../Assets/hidden.png';
import loading_gif from '../Assets/loading.gif';
import error1 from '../Assets/error1.png';


function ModerateUsers() 
{

    const [is_loaded, set_is_loaded] = useState(false);
    const [is_allowed, set_is_allowed] = useState(false);
    const [user_info, set_user_info] = useState({});
    const [users, set_users] = useState([]);

    const [unhidden_password, set_unhidden_password] = useState("");
    const [ongoing_process, set_ongoing_process] = useState({ process: "", id: "" });


    if (!is_loaded)
    {
        if (localStorage.getItem("user-id") == null || localStorage.getItem("user-id") == "")
        {
            set_is_loaded(true);
            set_is_allowed(false);
        }
        else
        {
            axios.post(`${proxy}/isAdmin`, { id: localStorage.getItem("user-id") })
            .then((res) => 
            {
                let data = res.data;

                if (data == "1")
                {
                    axios.post(`${proxy}/getUserById`, { id: localStorage.getItem("user-id") })
                        .then((res) => 
                        {
                            set_user_info(res.data[0]);
                            axios.post(`${proxy}/userData`)
                                .then((res) => 
                                {
                                    let data = res.data;

                                    set_users(data);
                                    set_is_loaded(true);
                                    set_is_allowed(true);
                                })
                                .catch((err) => console.error(err));
                        })
                        .catch((err) => console.error(err));
                }
                else
                {
                    set_is_loaded(true);
                    set_is_allowed(false);
                }
            })
            .catch((err) => console.error(err));
        }
    }


    function is_ongoing_process()
    {
        if (ongoing_process.process != "" || ongoing_process.id != "") return true;
        return false;
    }

    function reset_ongoing_process()
    {
        set_ongoing_process({ process: "", id: "" });
    }

    function setup_ongoing_process(process, id)
    {
        set_ongoing_process({ process: process, id: id });
    }

    function activate_user(id)
    {
        if (is_ongoing_process()) return;
        setup_ongoing_process("ad-user", id);

        axios.post(`${proxy}/activateUser`, { id: id })
            .then((res) => 
            {
                reset_ongoing_process();
                set_is_loaded(false);
            })
            .catch((err) => console.error(err));
    }

    function deactive_user(id)
    {
        if (is_ongoing_process()) return;    
        setup_ongoing_process("ad-user", id);

        axios.post(`${proxy}/deactivateUser`, { id: id })
            .then((res) => 
            {
                reset_ongoing_process();
                set_is_loaded(false);
            })
            .catch((err) => console.error(err));
    }

    function promote_user_to_admin(id)
    {
        if (is_ongoing_process()) return;
        setup_ongoing_process("admin", id);

        axios.post(`${proxy}/promoteToAdmin`, { id: id })
            .then((res) => 
            {
                reset_ongoing_process();
                set_is_loaded(false);
            })
            .catch((err) => console.error(err));
    }

    function demote_from_admin(id, admin_id)
    {
        if (is_ongoing_process()) return;
        setup_ongoing_process("admin", id);

        axios.post(`${proxy}/demoteFromAdmin`, { admin_id: admin_id })
            .then((res) => 
            {
                reset_ongoing_process();
                set_is_loaded(false);
            })
            .catch((err) => console.error(err));
    }


    if (!is_loaded) return <div></div>;
    if (!is_allowed) return (    
    <div style={{ width: "100%", height: "100vh", display: 'flex', flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
        <img src={error1} style={{ width: "80px" }} />
        <h1>Sorry! This page does not exist!</h1>
        <span>This page might be taken down or you have miss-entered the url!</span>
    </div>);

  return (
    <div className="content-container2" style={{ padding: "10px" }}>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
            <h1>Users & Actions</h1>
            <div style={{ display: "flex", alignItems: "center" }}>
                
                <button className={(unhidden_password == "") ? "btn-deactive" : "btn"} style={{ display: "flex", alignItems: "center", padding: "5px" }} onClick={(unhidden_password == "") ? () => {} : () => set_unhidden_password("")}>
                    <img src={hidden_icon} style={{ width: "25px", margin: "5px" }} />
                    <span>Hide All Passwords</span>
                </button>     
            </div>
        </div><br /> <br />

        <table>
            <tr>
                <th>#</th>
                <th>User ID</th>
                <th>Username</th>
                <th>Password</th>
                <th>Date Of Creation</th>
                <th>Is Admin</th>
                <th>Promote To Admin/Demote from Admin</th>
                <th>Remove Account</th>
            </tr>
            {
                users.map((value, index) =>
                <tr>
                    <td>{value.id}</td>
                    <td>{value.user_id}</td>
                    <td>{value.username}</td>
                    <td style={{ textAlign: "center" }}>{(unhidden_password == value.user_id) ? value.password : <button className="btn2" onClick={() => set_unhidden_password(value.user_id)}><img src={hidden_icon} style={{ height: "25px" }} /></button>}</td>
                    <td>{value.date_of_creation}</td>
                    <td>{(value.admin_id == null) ? "False" : "True"}</td>
                    <td style={{ textAlign: "center" }}>{(value.user_id == user_info.user_id) ? <span className="detail-gray" style={{ color: "gray" }}>(you cannot demote yourself.)</span> : (ongoing_process.process == "admin" && ongoing_process.id == value.user_id) ? <img src={loading_gif} style={{ width: "20px" }} /> : (value.admin_id == null) ? <button className="btn" style={{ backgroundColor: "green" }} onClick={() => promote_user_to_admin(value.user_id)}>Promote</button> : <button className="btn" style={{ backgroundColor: "tomato" }} onClick={() => demote_from_admin(value.user_id, value.admin_id)}>Demote</button>}</td>
                    <td style={{ textAlign: "center" }}>{(value.user_id == user_info.user_id) ? <span className="detail-gray" style={{ color: "gray" }}>(you cannot deactivate your account.)</span> : (ongoing_process.process == "ad-user" && ongoing_process.id == value.user_id) ? <img src={loading_gif} style={{ width: "20px" }} /> : (value.status == 1) ? <button className="btn" style={{ backgroundColor: "red" }} onClick={() => deactive_user(value.user_id)}>Deactivate User</button> : <button className="btn" onClick={() => activate_user(value.user_id)}>Activate User</button>}</td>
                    
                </tr>)
            }

        </table>
        <br />
    </div>
  );
}

export default ModerateUsers;